import {z} from 'zod';

export const SubscriptionCheckoutInput=z.object({
  requestId:z.uuid(),offerId:z.uuid(),buyerRef:z.string().trim().min(1).max(200),
  quantity:z.number().int().min(1).max(10000).default(1),
  returnUrl:z.url().max(2048).refine(value=>{const url=new URL(value);return url.protocol==='https:'&&!url.username&&!url.password&&!url.hash;},'Use an HTTPS return URL without credentials or a fragment.'),
}).strict();
export const SubscriptionCancelInput=z.object({requestId:z.uuid()}).strict();
export const MerchantSubscriptionViewSchema=z.object({
  mode:z.literal('live'),id:z.uuid(),offerId:z.uuid(),buyerRef:z.string(),quantity:z.number().int().positive(),
  interval:z.enum(['month','year']),status:z.string(),cancelAtPeriodEnd:z.boolean(),
  currentPeriodStart:z.iso.datetime().nullable(),currentPeriodEnd:z.iso.datetime().nullable(),paidThrough:z.iso.datetime().nullable(),
  fulfillmentReady:z.boolean(),latestOrderId:z.uuid().nullable(),checkoutUrl:z.url(),returnUrl:z.url(),needsReview:z.boolean(),
}).strict();
export type MerchantSubscriptionView=z.infer<typeof MerchantSubscriptionViewSchema>;
export type MerchantSubscriptionCheckout=z.input<typeof SubscriptionCheckoutInput>;
